import * as React from 'react';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { KeywordTextInput } from './keyword-text-input';
import { ActivityTypeaheadSearchInput } from './activity-typeahead-search-input';

export interface ActivityKeywordSearchInputProps {
  isCarousel?: boolean;
  inDialog?: boolean;
}

export const ActivityKeywordSearchInput: React.FC<ActivityKeywordSearchInputProps> = ({ isCarousel, inDialog }) => (
  <Viewport>
    <ViewSmall>
      <AbacusExperiment name="LX_Sort_Filter_Activities_Typeahead">
        <AbacusControl>
          <KeywordTextInput isCarousel={isCarousel} inDialog={inDialog} />
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <ActivityTypeaheadSearchInput isCarousel={isCarousel} />
        </AbacusVariant>
      </AbacusExperiment>
    </ViewSmall>
    <ViewMedium>
      <KeywordTextInput isCarousel={isCarousel} inDialog={inDialog} />
    </ViewMedium>
  </Viewport>
);
